import { IAdjustmentLocalResource, ILocalCouponAdjustment } from 'components/order/model/Order';
import logger from 'lib/logger';
import { isDefined } from 'lib/typeInference';

export interface ExistingSharedBasketData {
    selectedRewards?: IAdjustmentLocalResource[] | null;
    giftCard?: string | undefined;
    userSelectedTipValue?: number;
    tipValue?: number;
    coupons?: ILocalCouponAdjustment[];
}

const BASKET_SESSION_PREFIX = 'basket';

export const setBasketSession = (
    params: ExistingSharedBasketData,
    merchantId?: string,
    locationId?: string,
    checkId?: string,
    tableNumber?: string
) => {
    let keyString = `${BASKET_SESSION_PREFIX}-${merchantId}-${locationId}`;
    if (isDefined(checkId) || isDefined(tableNumber)) {
        keyString = `${keyString}-${checkId ?? ''}-${tableNumber ?? ''}`;
    }
    sessionStorage.setItem(keyString, JSON.stringify(params));
};

const getBasketSessionString = (
    merchantId?: string,
    locationId?: string,
    checkId?: string,
    tableNumber?: string
) => {
    let keyString = `${BASKET_SESSION_PREFIX}-${merchantId}-${locationId}`;
    if (isDefined(checkId) || isDefined(tableNumber)) {
        keyString = `${keyString}-${checkId ?? ''}-${tableNumber ?? ''}`;
    }
    const storedString = sessionStorage.getItem(keyString);
    return storedString;
};

export const getBasketSession = (
    merchantId?: string,
    locationId?: string,
    checkId?: string,
    tableNumber?: string
) => {
    let params: IAdjustmentLocalResource | undefined;
    try {
        const session = getBasketSessionString(merchantId, locationId, checkId, tableNumber);
        if (session) {
            const parsedSession = JSON.parse(session);
            if (parsedSession) {
                params = parsedSession;
            }
        }
    } catch (e) {
        logger.error(e);
    }
    return params;
};
